// Catálogo de sons de notificação disponíveis. Basta adicionar novos arquivos
// .mp3 em `src/assets/mp3/notifications/` — aparecem aqui automaticamente,
// sem precisar editar este arquivo.
const modules = import.meta.glob<{ default: string }>(
  "../assets/mp3/notifications/*.mp3",
  { eager: true },
);

export type NotificationSoundOption = {
  id: string;
  label: string;
  url: string;
};

// Sentinela para "sem som" — não corresponde a nenhum arquivo real.
export const MUTED_SOUND_ID = "none";

const toLabel = (fileName: string) =>
  fileName
    .replace(/[-_]+/g, " ")
    .replace(/\.mp3$/i, "")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const NOTIFICATION_SOUNDS: NotificationSoundOption[] = Object.entries(
  modules,
)
  .map(([path, mod]) => {
    const fileName = path.split("/").pop() ?? path;
    return { id: fileName, label: toLabel(fileName), url: mod.default };
  })
  .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));

if (NOTIFICATION_SOUNDS.length === 0) {
  // Build/deploy quebrado (pasta renomeada/movida): sem arquivo nenhum não há
  // som possível de tocar, mas isso não deveria falhar silenciosamente.
  console.warn(
    "[notificationSounds] Nenhum arquivo .mp3 encontrado em src/assets/mp3/notifications/.",
  );
}

export const DEFAULT_NOTIFICATION_SOUND_ID =
  NOTIFICATION_SOUNDS.find((s) => s.id === "notificacao.mp3")?.id ??
  NOTIFICATION_SOUNDS[0]?.id ??
  "";

export const getNotificationSoundUrl = (id: string): string | undefined =>
  NOTIFICATION_SOUNDS.find((s) => s.id === id)?.url;
